import classnames from 'classnames'

export const cx = classnames
